import React, { Component } from 'react'
import PropTypes from 'prop-types'
import formatter from '../../util/formatter'

import './styles.css'

export default class Section extends Component {
  render () {
    const { children, className, subtitle, title } = this.props

    return (
      <div className={formatter.toClassName(['wd-section-panel', className])}>
        <div className='title' style={{ display: title ? '' : 'none' }}>
          { title }

          <div style={{float: 'right'}}>{subtitle}</div>
        </div>

        <div className='body'>
          { children }
        </div>
      </div>
    )
  }
}

Section.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  style: PropTypes.object,
  subtitle: PropTypes.node,
  title: PropTypes.node
}
